import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'
import { ICONS } from '../../themes'

// Wrapper
// ============================================================
export const CountdownFlipTimerStyle = styled.div`
  /* Parent styles
  ------------------------------- */

  /* Child element styles
  ------------------------------- */
  .flip-countdown {
    .flip-countdown-piece {
      .flip-countdown-card {
        position: relative;
        padding-right: 10px;

        .flip-countdown-card-sec {
          .card__top,
          .card__back::before,
          .card__back::after {
            background-color: ${VARIABLES.COLORS.BLUE_1};
          }

          .card__top {
            border-color: transparent;
          }

          .card__bottom {
            background-color: ${VARIABLES.COLORS.BLUE_10};
          }
        }

        &:after {
          content: ':';
          display: block;
          font-size: 50px;
          position: absolute;
          right: 0;
          top: 0;
          line-height: 0.75;
          margin: 0 !important;
          width: 8px;
          font-family: ${VARIABLES.TYPOGRAPHYS.FONT_FAMILIES.FIRST};
          color: ${VARIABLES.COLORS.BLUE_1};
        }
      }

      &:last-child {
        .flip-countdown-card {
          &:after {
            display: none;
          }
        }
      }
    }

    &.size-small {
      .flip-countdown-piece {
        .flip-countdown-card {
          .flip-countdown-card-sec {
            font-size: 45px;
          }
        }

        .flip-countdown-title {
          font-weight: bold;
          color: ${VARIABLES.COLORS.BLUE_1};
          padding-right: 10px;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    .flip-countdown {
      .flip-countdown-piece {
        .flip-countdown-card {
          &:after {
            font-size: 42px;
          }
        }
      }

      &.size-small {
        .flip-countdown-piece {
          .flip-countdown-card {
            .flip-countdown-card-sec {
              font-size: 34px;
            }
          }

          .flip-countdown-title {
            font-size: 10px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1440.98px) {
  }

  @media all and (max-width: 1366.98px) {
    .flip-countdown {
      .flip-countdown-piece {
        .flip-countdown-card {
          &:after {
            font-size: 38px;
          }
        }
      }

      &.size-small {
        .flip-countdown-piece {
          .flip-countdown-card {
            .flip-countdown-card-sec {
              font-size: 28px;
            }
          }

          .flip-countdown-title {
            font-size: 10px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1280.98px) {
    .flip-countdown {
      .flip-countdown-piece {
        .flip-countdown-card {
          &:after {
            font-size: 42px;
          }
        }
      }

      &.size-small {
        .flip-countdown-piece {
          .flip-countdown-card {
            .flip-countdown-card-sec {
              font-size: 34px;
            }
          }

          .flip-countdown-title {
            font-size: 10px;
          }
        }
      }
    }
  }

  @media all and (max-width: 1024.98px) {
    /* .flip-countdown {
      .flip-countdown-piece {
        .flip-countdown-card {
          &:after {
            font-size: 42px;
          }
        }
      }

      &.size-small {
        .flip-countdown-piece {
          .flip-countdown-card {
            .flip-countdown-card-sec {
              font-size: 34px;
            }
          }

          .flip-countdown-title {
            font-size: 10px;
          }
        }
      }
    } */
  }
`
